import React from "react";

export default function Agents({
  agents, agentName, setAgentName, agentSalary, setAgentSalary, addAgent,
  searchedAgentPerformance, handleFileUpload, downloadSampleCSV, inputClass,
  exportToCSV, exportToExcel
}) {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-800">Agent Data</h2>
          <p className="text-slate-500 text-sm">Upload bulk agents via CSV or enter manually</p>
        </div>
        <div className="text-right">
          <button onClick={() => document.getElementById("agent-upload").click()} className="bg-white border border-slate-300 hover:bg-slate-50 text-slate-800 px-4 py-2 rounded-lg text-sm font-semibold shadow-sm transition-all">
            📤 Upload Agents
          </button>
          <input id="agent-upload" type="file" accept=".csv" onChange={(e) => handleFileUpload(e, "agents")} className="hidden" />
          <p onClick={() => downloadSampleCSV("agents")} className="text-blue-600 text-sm mt-2 cursor-pointer font-medium hover:underline">Download Sample CSV</p>
        </div>
      </div>
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h2 className="text-lg font-bold text-slate-800 mb-4">Add Agent</h2>
        <div className="flex gap-4">
          <input type="text" placeholder="Agent Name" value={agentName} onChange={(e) => setAgentName(e.target.value)} className={inputClass} />
          <input type="number" placeholder="Salary" value={agentSalary} onChange={(e) => setAgentSalary(e.target.value)} className={inputClass} />
        </div>
        <button onClick={addAgent} className="mt-4 bg-slate-900 hover:bg-slate-800 text-white px-6 py-2 rounded-lg text-sm font-semibold shadow-sm transition-all">Add Agent</button>
      </div>
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-slate-800">👥 Agent Performance</h2>
          <div className="flex gap-2">
            <button onClick={() => exportToCSV(searchedAgentPerformance, "agent_performance")} className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 px-2 py-1 rounded transition-colors">CSV</button>
            <button onClick={() => exportToExcel(searchedAgentPerformance, "agent_performance")} className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 px-2 py-1 rounded transition-colors">Excel</button>
          </div>
        </div>
        <div className="space-y-3">
          {searchedAgentPerformance.map((agent) => (
            <div key={agent.id} className="flex flex-col md:flex-row md:items-center justify-between bg-white border border-slate-200 p-4 rounded-xl hover:border-blue-300 transition-all duration-200">
              <div>
                <span className="font-semibold text-slate-800">{agent.name}</span>
                <div className="text-xs text-slate-500 mt-1 flex gap-2">
                  <span>Salary: ₹{agent.salary}</span>
                  <span>• Leads: {agent.leadsCount}</span>
                  <span>• Activated: {agent.activatedCount}</span>
                </div>
              </div>
              <div className="flex flex-col items-end mt-2 md:mt-0">
                <span className="font-bold bg-slate-50 text-slate-800 px-3 py-1 rounded-lg text-sm border border-slate-100">
                  Rev: ₹{agent.revenue} | Profit: <span className={agent.profit >= 0 ? "text-emerald-600" : "text-red-600"}>₹{agent.profit}</span>
                </span>
                <div className="text-xs text-slate-500 mt-1 flex gap-2">
                  <span>Act. Rate: {agent.activationRate}%</span>
                  <span>• Rev/Lead: ₹{agent.revenuePerLead}</span>
                </div>
              </div>
            </div>
          ))}
          {searchedAgentPerformance.length === 0 && (
            <div className="p-4 text-center text-slate-400">No agents found.</div>
          )}
        </div>
      </div>
    </div>
  );
}